import React, { useMemo } from 'react';
import './ViewClassProgress.css';
import { StarFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import play from '../../Assets/play.png';

function ViewClassProgress({ classData }) {
  const navigate = useNavigate();

  const handleViewClass = (classId) => {
    navigate(`/class/${classId}`);
  };

    // Generate Thumbnail Source - Updated to use UID format
    const thumbnailSrc = useMemo(() => {
      if (classData.id) {
        const newUrl = `https://beyondschools.co.tz:8443/api/Public/get-class-thumbnail/${classData.id}`;
        console.log('Using new URL format:', newUrl);
        return newUrl;
      }
    },);

  const formatDuration = (totalSeconds) => {
    if (!totalSeconds) return '0m';
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0 || hours === 0) parts.push(`${minutes}m`);
    return parts.join(' ');
  };

  return (
    <div className='view-class-progress-container'>
      <div className="class-image-progress" onClick={() => handleViewClass(classData?.id)} style={{ backgroundImage: `url(${thumbnailSrc})` }}>
        <img src={play} alt="Play Icon" className="play-toggle" />
      </div>

      <div className='view-class-progress-details'>
        <div className='teacher-price'>
          <span className='teacher-name'>{classData?.instructor || 'Instructor Name Not Available'}</span>
          {/* <span className='price-value'>Tsh {classData?.cost?.toLocaleString() || '0'}</span> */}
        </div>

        <p className='class-progress-title'>{classData?.title || 'Class Title Not Available'}</p>

        <div className='class-progress-description-container'>
          <div className="single-star-rating">
            <StarFilled className="star-icon" />
            <span className="rating-value">4.5</span>
          </div>

          <div className="single-star-rating">
            <span className="rating-value">{classData?.education_class}</span>
          </div>
        </div>

        <div className='progress-container'>
          <div className='progress-bar' style={{ width: `${classData?.progress || 0}%` }}></div>
        </div>

        <div className='class-progress-watch'>
          <span className='progress-text'>{classData?.progress || 0}% Complete</span>
          <span className='duration'>{formatDuration(classData?.duration)}</span>
        </div>
      </div>
      </div>
  );
}

export default ViewClassProgress;